import { makeAutoObservable, runInAction } from "mobx";

import { AddressDTO } from "../DTOs/Address/AddressDTO";
import { addressAjaxController } from "../Ajax/AddressAjaxController";
import { basketController } from "./BasketController";
import { deliveryDetailsController } from "../../Pages/CheckoutPage/Controllers/DeliveryDetailsController";

class AddressesController {
  addresses: AddressDTO[] = [];
  selectedDeliveryAddress: AddressDTO | null = null;
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  get billingAddress() {
    return this.addresses.find(a => a.isBillingAddress) ?? null;
  }

  get deliveryAddresses() {
    return this.addresses.filter(a => !a.isBillingAddress);
  }

  get allAddresses() {
    return this.addresses;
  }

  async selectDeliveryAddress(addr: AddressDTO) {
    if (!basketController.basket) return;
    this.selectedDeliveryAddress = addr;

    try {
      if (addr.id !== basketController.basket.addressId)
        await basketController.updateBasketAddress(addr.id)

      await deliveryDetailsController.getDeliveryOptions();
    } catch (err) {
    }
  }

  async fetchAddresses() {
    this.isLoading = true;
    try {
      const res = await addressAjaxController.getAddresses();
      runInAction(() => this.addresses = res)

      let defaultAddress: AddressDTO | undefined;

      if (basketController.basket && basketController.basket.addressId)
        defaultAddress = res.find(a => a.id === basketController.basket!.addressId);

      runInAction(() => this.selectedDeliveryAddress = defaultAddress ?? res.find(a => a.isBillingAddress) ?? null)
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  async addAddress(address: AddressDTO) {
    const res = await addressAjaxController.updateAddress(address);
    runInAction(() => this.addresses.push(res));
  }

  async editAddress(updated: AddressDTO) {
    const res = await addressAjaxController.updateAddress(updated);
    runInAction(() => {
      const index = this.addresses.findIndex(a => a.id === updated.id);
      if (index >= 0) this.addresses[index] = res;
    });
  }

  async deleteAddress(id: number) {
    await addressAjaxController.deleteAddress(id);
    runInAction(() => {
      this.addresses = this.addresses.filter(a => a.id !== id);
      if (this.selectedDeliveryAddress?.id === id) {
        this.selectedDeliveryAddress = null;
      }
    });
  }
}

export const addressesController = new AddressesController();